/* tslint:disable */
/* eslint-disable */
/**
 * Twometerguide API
 * API for the Twometerguide booking module
 *
 * The version of the OpenAPI document: 0.0.1
 * Contact: prot-two-meter-guide@7bits.it
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TravelineRoomStayServiceRsDto } from './traveline-room-stay-service-rs-dto';
import {
    TravelineRoomStayServiceRsDtoFromJSON,
    TravelineRoomStayServiceRsDtoFromJSONTyped,
    TravelineRoomStayServiceRsDtoToJSON,
    TravelineRoomStayServiceRsDtoToJSONTyped,
} from './traveline-room-stay-service-rs-dto';
import type { TravelineBookingDailyRateDto } from './traveline-booking-daily-rate-dto';
import {
    TravelineBookingDailyRateDtoFromJSON,
    TravelineBookingDailyRateDtoFromJSONTyped,
    TravelineBookingDailyRateDtoToJSON,
    TravelineBookingDailyRateDtoToJSONTyped,
} from './traveline-booking-daily-rate-dto';
import type { TravelineBookingGuestCountDto } from './traveline-booking-guest-count-dto';
import {
    TravelineBookingGuestCountDtoFromJSON,
    TravelineBookingGuestCountDtoFromJSONTyped,
    TravelineBookingGuestCountDtoToJSON,
    TravelineBookingGuestCountDtoToJSONTyped,
} from './traveline-booking-guest-count-dto';
import type { TravelineBookingRoomTypeRsDto } from './traveline-booking-room-type-rs-dto';
import {
    TravelineBookingRoomTypeRsDtoFromJSON,
    TravelineBookingRoomTypeRsDtoFromJSONTyped,
    TravelineBookingRoomTypeRsDtoToJSON,
    TravelineBookingRoomTypeRsDtoToJSONTyped,
} from './traveline-booking-room-type-rs-dto';
import type { TravelineExtraStaysChargeDto } from './traveline-extra-stays-charge-dto';
import {
    TravelineExtraStaysChargeDtoFromJSON,
    TravelineExtraStaysChargeDtoFromJSONTyped,
    TravelineExtraStaysChargeDtoToJSON,
    TravelineExtraStaysChargeDtoToJSONTyped,
} from './traveline-extra-stays-charge-dto';
import type { TravelineBookingGuestDto } from './traveline-booking-guest-dto';
import {
    TravelineBookingGuestDtoFromJSON,
    TravelineBookingGuestDtoFromJSONTyped,
    TravelineBookingGuestDtoToJSON,
    TravelineBookingGuestDtoToJSONTyped,
} from './traveline-booking-guest-dto';
import type { TravelineBookingRatePlanRsDto } from './traveline-booking-rate-plan-rs-dto';
import {
    TravelineBookingRatePlanRsDtoFromJSON,
    TravelineBookingRatePlanRsDtoFromJSONTyped,
    TravelineBookingRatePlanRsDtoToJSON,
    TravelineBookingRatePlanRsDtoToJSONTyped,
} from './traveline-booking-rate-plan-rs-dto';
import type { TravelineBookingTotalDto } from './traveline-booking-total-dto';
import {
    TravelineBookingTotalDtoFromJSON,
    TravelineBookingTotalDtoFromJSONTyped,
    TravelineBookingTotalDtoToJSON,
    TravelineBookingTotalDtoToJSONTyped,
} from './traveline-booking-total-dto';
import type { TravelineBookingStayDatesDto } from './traveline-booking-stay-dates-dto';
import {
    TravelineBookingStayDatesDtoFromJSON,
    TravelineBookingStayDatesDtoFromJSONTyped,
    TravelineBookingStayDatesDtoToJSON,
    TravelineBookingStayDatesDtoToJSONTyped,
} from './traveline-booking-stay-dates-dto';

/**
 * Room accommodation entity
 * @export
 * @interface TravelineBookingRoomStayRsDto
 */
export interface TravelineBookingRoomStayRsDto {
    /**
     * 
     * @type {TravelineBookingStayDatesDto}
     * @memberof TravelineBookingRoomStayRsDto
     */
    stayDates: TravelineBookingStayDatesDto;
    /**
     * 
     * @type {TravelineBookingRatePlanRsDto}
     * @memberof TravelineBookingRoomStayRsDto
     */
    ratePlan: TravelineBookingRatePlanRsDto;
    /**
     * 
     * @type {TravelineBookingRoomTypeRsDto}
     * @memberof TravelineBookingRoomStayRsDto
     */
    roomType: TravelineBookingRoomTypeRsDto;
    /**
     * Guests entity
     * @type {Array<TravelineBookingGuestDto>}
     * @memberof TravelineBookingRoomStayRsDto
     */
    guests: Array<TravelineBookingGuestDto>;
    /**
     * 
     * @type {TravelineBookingGuestCountDto}
     * @memberof TravelineBookingRoomStayRsDto
     */
    guestCount: TravelineBookingGuestCountDto;
    /**
     * Check hash sum of accommodation conditions
     * @type {string}
     * @memberof TravelineBookingRoomStayRsDto
     */
    checksum: string;
    /**
     * Price breakdown by day
     * @type {Array<TravelineBookingDailyRateDto>}
     * @memberof TravelineBookingRoomStayRsDto
     */
    dailyRates?: Array<TravelineBookingDailyRateDto> | null;
    /**
     * 
     * @type {TravelineBookingTotalDto}
     * @memberof TravelineBookingRoomStayRsDto
     */
    total?: TravelineBookingTotalDto;
    /**
     * Extra services in a booking<br />
     * @type {Array<TravelineRoomStayServiceRsDto>}
     * @memberof TravelineBookingRoomStayRsDto
     */
    services?: Array<TravelineRoomStayServiceRsDto> | null;
    /**
     * 
     * @type {TravelineExtraStaysChargeDto}
     * @memberof TravelineBookingRoomStayRsDto
     */
    extraStayCharge?: TravelineExtraStaysChargeDto;
}

/**
 * Check if a given object implements the TravelineBookingRoomStayRsDto interface.
 */
export function instanceOfTravelineBookingRoomStayRsDto(value: object): value is TravelineBookingRoomStayRsDto {
    if (!('stayDates' in value) || value['stayDates'] === undefined) return false;
    if (!('ratePlan' in value) || value['ratePlan'] === undefined) return false;
    if (!('roomType' in value) || value['roomType'] === undefined) return false;
    if (!('guests' in value) || value['guests'] === undefined) return false;
    if (!('guestCount' in value) || value['guestCount'] === undefined) return false;
    if (!('checksum' in value) || value['checksum'] === undefined) return false;
    return true;
}

export function TravelineBookingRoomStayRsDtoFromJSON(json: any): TravelineBookingRoomStayRsDto {
    return TravelineBookingRoomStayRsDtoFromJSONTyped(json, false);
}

export function TravelineBookingRoomStayRsDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): TravelineBookingRoomStayRsDto {
    if (json == null) {
        return json;
    }
    return {
        
        'stayDates': TravelineBookingStayDatesDtoFromJSON(json['stayDates']),
        'ratePlan': TravelineBookingRatePlanRsDtoFromJSON(json['ratePlan']),
        'roomType': TravelineBookingRoomTypeRsDtoFromJSON(json['roomType']),
        'guests': ((json['guests'] as Array<any>).map(TravelineBookingGuestDtoFromJSON)),
        'guestCount': TravelineBookingGuestCountDtoFromJSON(json['guestCount']),
        'checksum': json['checksum'],
        'dailyRates': json['dailyRates'] == null ? undefined : ((json['dailyRates'] as Array<any>).map(TravelineBookingDailyRateDtoFromJSON)),
        'total': json['total'] == null ? undefined : TravelineBookingTotalDtoFromJSON(json['total']),
        'services': json['services'] == null ? undefined : ((json['services'] as Array<any>).map(TravelineRoomStayServiceRsDtoFromJSON)),
        'extraStayCharge': json['extraStayCharge'] == null ? undefined : TravelineExtraStaysChargeDtoFromJSON(json['extraStayCharge']),
    };
}

  export function TravelineBookingRoomStayRsDtoToJSON(json: any): TravelineBookingRoomStayRsDto {
      return TravelineBookingRoomStayRsDtoToJSONTyped(json, false);
  }

  export function TravelineBookingRoomStayRsDtoToJSONTyped(value?: TravelineBookingRoomStayRsDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'stayDates': TravelineBookingStayDatesDtoToJSON(value['stayDates']),
        'ratePlan': TravelineBookingRatePlanRsDtoToJSON(value['ratePlan']),
        'roomType': TravelineBookingRoomTypeRsDtoToJSON(value['roomType']),
        'guests': ((value['guests'] as Array<any>).map(TravelineBookingGuestDtoToJSON)),
        'guestCount': TravelineBookingGuestCountDtoToJSON(value['guestCount']),
        'checksum': value['checksum'],
        'dailyRates': value['dailyRates'] == null ? undefined : ((value['dailyRates'] as Array<any>).map(TravelineBookingDailyRateDtoToJSON)),
        'total': TravelineBookingTotalDtoToJSON(value['total']),
        'services': value['services'] == null ? undefined : ((value['services'] as Array<any>).map(TravelineRoomStayServiceRsDtoToJSON)),
        'extraStayCharge': TravelineExtraStaysChargeDtoToJSON(value['extraStayCharge']),
    };
}

